// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Main Container */
.main-container {
  background-color: #e5e5e5;
  margin: 0; 
  padding: 0; 
  height: 100%;
}

/* Heading */
.heading {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 5.5rem;
  font-style: normal;
  line-height: 100%;
  margin-top: 50px;
}

.sub-heading-1 {
  color: rgb(18, 57, 77);
  font-family: "Roboto Bold", sans-serif;
}

.sub-heading-2 {
  font-family: "Roboto-Slab";
  color: rgb(66, 126, 147);
  font-weight: 200;
}

/* Sub Heading - Explore */
.sub-heading-font {
  color: #333;
  font-family: "Roboto Bold", sans-serif;
  /* font-size: 50%; */
}

/* Sub Heading - Arab American History */
.sub-heading-font2 {
  font-family: "Roboto-Slab", sans-serif;
  color: #427e93;
  font-weight: 200;
}

/* Search Div */
.search-div {
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 60px;
}

/* Search Input */
.search-input {
  text-indent: 10%;
  font-size: 22px;
  height: 68px;
  width: 720px;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  border-bottom: 2px solid #cccccc;
  border-radius: 36px;
  font-family: "Roboto", sans-serif;
}

/* Or Image Div */
.or-image-div {
  height: 24px;
  width: 22px;
  font-family: "Roboto Slab", sans-serif;
  font-style: normal;
  font-weight: 400;
  /* font-size: 16px; */
  /* line-height: 150%; */
  text-align: center;
  color: #fff;
  margin-top: 20px;
}

.or-image-div svg{
  width: 500px;
  /* height: auto; */
}

@media (max-width: 550px){
  .or-image-div svg{
    width: 90%;
  }
}


/* Browse Collection Div */
.browse-collection-div {
  display: flex;
  justify-content: center;
  text-align: center;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 100%;
  margin-top: 25px;
  margin-bottom: 20px;
}
.row.g-0 .browse-collection-div {
  margin-bottom: 16px;
}
.row.g-0 + .browse-collection-div {
  margin-top: 20px;
}

/* Browse Text - Browse our collection */
.browse-text-span {
  color: #333;
  font-family: "Roboto Bold", sans-serif;
}

/* Browse Text - By Selecting */
.by-selecting-span {
  color: #999;
  margin-top: 5px;
  display: inline-block;
}

/* Newspaper Button */
.browse-button {
  text-indent: 5%;
  height: 48px;
  width: 15rem;
  padding: 5px;
  background: #fff;
  align-items: center;
  border: 1px solid #cccccc;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  font-style: normal;
  background-color: #fff;
  text-align: left;
}

/* Smaller Search Icon */
.smaller-search-icon {
  color: #ff0000;
  height: 14px;
  float: right;
  margin-right: 10px;
  margin-top: 2px;
  display: flex;
  align-items: center;
}

/* Collections Div */
.collections-div {
  text-align: center;
  border-right: 2px solid #cccccc;
}

/* Icon Style */
.icon-style {
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: end;
}

/* Info Style */
.info-style {
  padding: 8px;
  margin: 0px;
  display: flex;
  align-items: center;
}

/* Span Style - 4382 */
.span-style-4382 {
  font-family: "Roboto-Slab", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 40px;
  color: #427e93;
}

/* Span Style - Below 4382 */
.span-style-below-4382 {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
  color: #808080;
}

/* Search and Browse Div */
.search-browse-div {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  max-width: 960px;
  margin: 0 auto;
  padding: 16px 20px 32px;
  text-align: center;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 0.95rem;
  line-height: 1.5;
  color: #666666;
}

.search-browse-div p {
  margin: 6px 0;
}

/* Learn more about Fihris link (under stats) */
.home-video-buttons-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  margin: 1.5rem auto 0;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}
.learn-more-fihris-link {
  display: inline-block;
  margin: 0;
  flex: 1 1;
  min-width: 200px;
  padding: 0.5rem 1rem;
  text-align: center;
  background: transparent;
  border: 2px solid #427e93;
  color: #427e93;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}
.learn-more-fihris-link:hover {
  background-color: #427e93;
  color: #fff;
}

/* Fihris trailer modal */
.fihris-trailer-modal .modal-dialog {
  max-width: 90vw;
}
.fihris-trailer-modal-body {
  display: flex;
  justify-content: center;
  padding: 1rem;
}
.fihris-trailer-modal-video {
  max-width: 100%;
  width: 100%;
  height: auto;
}

/* Tutorial modal (YouTube embed) */
.tutorial-video-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
  overflow: hidden;
}
.tutorial-video-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.disclaimer-heading {
  font-weight: 700;
  font-size: 0.85rem;
  letter-spacing: 0.08em;
  color: #427e93;
}

@media (max-width: 600px){
  .search-browse-div{
    font-size: 0.9rem;
    padding: 12px 16px 24px;
  }
}

/* Learn More Span */
.learn-more-span {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 167%;
  color: #ff0000;
}

/* Drop Down Style */
.drop-down-style {
  height: 48px;
  border: 1px solid #cccccc;
  border-radius: 36px;
  background-color: #ffffff;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #808080;
  padding-left: 10px;
}


.stats{
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: solid #cccccc;
  margin: 1%;
}

.periodicals-books{
  display: flex;
  justify-content: center;
  justify-content: space-evenly;
}

@media (max-width: 700px) {
  .heading{
    font-size: 4.5rem;
  }
}

@media (max-width: 380px) {
  .heading{
    font-size: 3.5rem;
  }
}

@media (max-width: 600px){
  .periodicals-books{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
   
  }
  .periodicals{
    margin: 20px;
  }
}

/* Team section */
.team-section {
  padding: 1.5rem 20px 1.5rem;
  max-width: 960px;
  margin: 0 auto;
  border-top: 1px solid #e5e5e5;
}

.team-section-heading {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 1.25rem;
  letter-spacing: 0.08em;
  color: #427e93;
  text-align: center;
  margin-bottom: 1rem;
}

.team-section-content {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem 2rem;
  max-width: 800px;
  margin: 0 auto;
}

.team-block {
  min-width: 0;
}

.team-role {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 0.95rem;
  color: rgb(18, 57, 77);
  margin-bottom: 0.25rem;
}

.team-list {
  list-style: none;
  padding-left: 0;
  margin: 0;
  font-family: "Roboto", sans-serif;
  font-size: 0.95rem;
  line-height: 1.45;
  color: #666666;
}

.team-list li::before {
  content: "• ";
  color: #427e93;
  font-weight: 700;
}

@media (max-width: 700px) {
  .team-section-content {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 400px) {
  .team-section-content {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/home.css"],"names":[],"mappings":";AACA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA,wCAAwC;AACxC;EACE,sCAAsC;EACtC,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,WAAW;EACX,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;;AAGA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,sCAAsC;AACxC;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,SAAS;EACT,SAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,6CAA6C;AAC/C;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB,EAAE,SAAS;EACjC,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;IACjB,uBAAuB;EACzB;AACF;;AAEA,oBAAoB;AACpB;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;;EAEzB;EACA;IACE,YAAY;EACd;AACF;;AAEA,iBAAiB;AACjB;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["\n/* Main Container */\n.main-container {\n  background-color: #e5e5e5;\n  margin: 0; \n  padding: 0; \n  height: 100%;\n}\n\n/* Heading */\n.heading {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 700;\n  font-size: 5.5rem;\n  font-style: normal;\n  line-height: 100%;\n  margin-top: 50px;\n}\n\n.sub-heading-1 {\n  color: rgb(18, 57, 77);\n  font-family: \"Roboto Bold\", sans-serif;\n}\n\n.sub-heading-2 {\n  font-family: \"Roboto-Slab\";\n  color: rgb(66, 126, 147);\n  font-weight: 200;\n}\n\n/* Sub Heading - Explore */\n.sub-heading-font {\n  color: #333;\n  font-family: \"Roboto Bold\", sans-serif;\n  /* font-size: 50%; */\n}\n\n/* Sub Heading - Arab American History */\n.sub-heading-font2 {\n  font-family: \"Roboto-Slab\", sans-serif;\n  color: #427e93;\n  font-weight: 200;\n}\n\n/* Search Div */\n.search-div {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  margin-top: 60px;\n}\n\n/* Search Input */\n.search-input {\n  text-indent: 10%;\n  font-size: 22px;\n  height: 68px;\n  width: 720px;\n  border-top: 0px;\n  border-left: 0px;\n  border-right: 0px;\n  border-bottom: 2px solid #cccccc;\n  border-radius: 36px;\n  font-family: \"Roboto\", sans-serif;\n}\n\n/* Or Image Div */\n.or-image-div {\n  height: 24px;\n  width: 22px;\n  font-family: \"Roboto Slab\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  /* font-size: 16px; */\n  /* line-height: 150%; */\n  text-align: center;\n  color: #fff;\n  margin-top: 20px;\n}\n\n.or-image-div svg{\n  width: 500px;\n  /* height: auto; */\n}\n\n@media (max-width: 550px){\n  .or-image-div svg{\n    width: 90%;\n  }\n}\n\n\n/* Browse Collection Div */\n.browse-collection-div {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  font-family: \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 28px;\n  line-height: 100%;\n  margin-top: 25px;\n  margin-bottom: 20px;\n}\n.row.g-0 .browse-collection-div {\n  margin-bottom: 16px;\n}\n.row.g-0 + .browse-collection-div {\n  margin-top: 20px;\n}\n\n/* Browse Text - Browse our collection */\n.browse-text-span {\n  color: #333;\n  font-family: \"Roboto Bold\", sans-serif;\n}\n\n/* Browse Text - By Selecting */\n.by-selecting-span {\n  color: #999;\n  margin-top: 5px;\n  display: inline-block;\n}\n\n/* Newspaper Button */\n.browse-button {\n  text-indent: 5%;\n  height: 48px;\n  width: 15rem;\n  padding: 5px;\n  background: #fff;\n  align-items: center;\n  border: 1px solid #cccccc;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  font-style: normal;\n  background-color: #fff;\n  text-align: left;\n}\n\n/* Smaller Search Icon */\n.smaller-search-icon {\n  color: #ff0000;\n  height: 14px;\n  float: right;\n  margin-right: 10px;\n  margin-top: 2px;\n  display: flex;\n  align-items: center;\n}\n\n/* Collections Div */\n.collections-div {\n  text-align: center;\n  border-right: 2px solid #cccccc;\n}\n\n/* Icon Style */\n.icon-style {\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}\n\n/* Info Style */\n.info-style {\n  padding: 8px;\n  margin: 0px;\n  display: flex;\n  align-items: center;\n}\n\n/* Span Style - 4382 */\n.span-style-4382 {\n  font-family: \"Roboto-Slab\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 40px;\n  color: #427e93;\n}\n\n/* Span Style - Below 4382 */\n.span-style-below-4382 {\n  font-family: \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 150%;\n  color: #808080;\n}\n\n/* Search and Browse Div */\n.search-browse-div {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  max-width: 960px;\n  margin: 0 auto;\n  padding: 16px 20px 32px;\n  text-align: center;\n  font-family: \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  color: #666666;\n}\n\n.search-browse-div p {\n  margin: 6px 0;\n}\n\n/* Learn more about Fihris link (under stats) */\n.home-video-buttons-row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 1rem;\n  margin: 1.5rem auto 0;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.learn-more-fihris-link {\n  display: inline-block;\n  margin: 0;\n  flex: 1 1 0;\n  min-width: 200px;\n  padding: 0.5rem 1rem;\n  text-align: center;\n  background: transparent;\n  border: 2px solid #427e93;\n  color: #427e93;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 700;\n  font-size: 0.95rem;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: background-color 0.2s, color 0.2s;\n}\n.learn-more-fihris-link:hover {\n  background-color: #427e93;\n  color: #fff;\n}\n\n/* Fihris trailer modal */\n.fihris-trailer-modal .modal-dialog {\n  max-width: 90vw;\n}\n.fihris-trailer-modal-body {\n  display: flex;\n  justify-content: center;\n  padding: 1rem;\n}\n.fihris-trailer-modal-video {\n  max-width: 100%;\n  width: 100%;\n  height: auto;\n}\n\n/* Tutorial modal (YouTube embed) */\n.tutorial-video-wrapper {\n  position: relative;\n  width: 100%;\n  padding-bottom: 56.25%; /* 16:9 */\n  height: 0;\n  overflow: hidden;\n}\n.tutorial-video-iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n.disclaimer-heading {\n  font-weight: 700;\n  font-size: 0.85rem;\n  letter-spacing: 0.08em;\n  color: #427e93;\n}\n\n@media (max-width: 600px){\n  .search-browse-div{\n    font-size: 0.9rem;\n    padding: 12px 16px 24px;\n  }\n}\n\n/* Learn More Span */\n.learn-more-span {\n  font-family: \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 167%;\n  color: #ff0000;\n}\n\n/* Drop Down Style */\n.drop-down-style {\n  height: 48px;\n  border: 1px solid #cccccc;\n  border-radius: 36px;\n  background-color: #ffffff;\n  font-family: \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 150%;\n  color: #808080;\n  padding-left: 10px;\n}\n\n\n.stats{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-left: solid #cccccc;\n  margin: 1%;\n}\n\n.periodicals-books{\n  display: flex;\n  justify-content: center;\n  justify-content: space-evenly;\n}\n\n@media (max-width: 700px) {\n  .heading{\n    font-size: 4.5rem;\n  }\n}\n\n@media (max-width: 380px) {\n  .heading{\n    font-size: 3.5rem;\n  }\n}\n\n@media (max-width: 600px){\n  .periodicals-books{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n   \n  }\n  .periodicals{\n    margin: 20px;\n  }\n}\n\n/* Team section */\n.team-section {\n  padding: 1.5rem 20px 1.5rem;\n  max-width: 960px;\n  margin: 0 auto;\n  border-top: 1px solid #e5e5e5;\n}\n\n.team-section-heading {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 700;\n  font-size: 1.25rem;\n  letter-spacing: 0.08em;\n  color: #427e93;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.team-section-content {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem 2rem;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.team-block {\n  min-width: 0;\n}\n\n.team-role {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 700;\n  font-size: 0.95rem;\n  color: rgb(18, 57, 77);\n  margin-bottom: 0.25rem;\n}\n\n.team-list {\n  list-style: none;\n  padding-left: 0;\n  margin: 0;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 0.95rem;\n  line-height: 1.45;\n  color: #666666;\n}\n\n.team-list li::before {\n  content: \"• \";\n  color: #427e93;\n  font-weight: 700;\n}\n\n@media (max-width: 700px) {\n  .team-section-content {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 400px) {\n  .team-section-content {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
